import { useState } from "react";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { api, errMsg, fmtDate } from "../lib/api";
import { PageHeader, useLoad, Empty, LeadDetail } from "../components/common";

export default function FundedPage({ me }) {
  const isAdmin = me.role === "admin";
  const [open, setOpen] = useState(null);
  const [data, reload] = useLoad(async () => (await api.get("/funded")).data);
  const reverse = async (l) => {
    const reason = window.prompt("Reason for reversing funded status (required)");
    if (!reason) return;
    try { await api.post(`/leads/${l.id}/unfund`, { reason }); toast.success("Funded status reversed"); reload(); } catch (e) { toast.error(errMsg(e)); }
  };
  const correct = async (l) => {
    const amount = window.prompt("Corrected funding amount (leave blank to keep)", l.funded?.amount ?? "");
    const reason = window.prompt("Reason for correction (required)");
    if (!reason) return;
    try { await api.patch(`/leads/${l.id}/funded`, { amount: amount ? Number(amount) : null, reason }); toast.success("Corrected"); reload(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div data-testid="funded-page">
      <PageHeader title="Funded deals" sub="Funded leads are permanently out of rotation and stay with the responsible rep, leader and admin." />
      <div className="panel overflow-x-auto">
        {!data?.items?.length ? <Empty text="No funded deals yet." /> : (
          <table className="dt" data-testid="funded-table"><thead><tr><th>Business</th><th>Contact</th><th>Funding date</th><th className="num">Amount</th><th>Lender</th><th>Marked by</th><th /></tr></thead>
            <tbody>{data.items.map((l) => (
              <tr key={l.id} data-testid={`funded-row-${l.id}`}><td className="font-medium">{l.business_name || "—"}</td><td>{l.contact_name || "—"}</td>
                <td className="mono text-xs">{l.funded?.funding_date}</td><td className="num">{l.funded?.amount != null ? `$${Number(l.funded.amount).toLocaleString()}` : "—"}</td>
                <td>{l.funded?.lender || "—"}</td><td className="text-xs">{l.funded?.marked_by_name} · {fmtDate(l.funded?.marked_at)}</td>
                <td className="text-right space-x-1 whitespace-nowrap">
                  <Button size="sm" variant="outline" onClick={() => setOpen(l.id)} data-testid={`funded-open-${l.id}`}>Open</Button>
                  {isAdmin && <Button size="sm" variant="outline" onClick={() => correct(l)} data-testid={`funded-correct-${l.id}`}>Correct</Button>}
                  {isAdmin && <Button size="sm" variant="destructive" onClick={() => reverse(l)} data-testid={`funded-reverse-${l.id}`}>Reverse</Button>}
                </td></tr>))}
            </tbody></table>)}
      </div>
      <LeadDetail id={open} onClose={() => setOpen(null)} isAdmin={isAdmin} />
    </div>
  );
}
